import { Form } from '@unistocks/components/form/form';
import { AssetFilter } from '@unistocks/features/admin/components/asset-management/asset-filter';
import { t } from '@unistocks/shared/localization/index.ts';
import { translateEnumOptions } from '@unistocks/shared/utils/enum-utils';
import { assetTypeOptions } from '@unistocks/shared/utils/enums/asset-type-options';
import { dataSourceOptions } from '@unistocks/shared/utils/enums/data-source-options';
import { FormProps } from '@unistocks/types/form-props';

export const AssetFilterForm: React.FC<FormProps<AssetFilter>> = props => {
  return (
    <Form triggerText={t('::Apply')} {...props}>
      <Form.Select
        multiple
        name={'assetType'}
        label={t('::AssetType')}
        options={translateEnumOptions(assetTypeOptions)}
      />
      <Form.Select
        multiple
        name={'dataSource'}
        label={t('::DataSource')}
        options={dataSourceOptions}
      />
    </Form>
  );
};

AssetFilterForm.displayName = 'AssetFilterForm';
